module.exports = __webpack_public_path__ + "img/wheel.0316be81.svg";